import { QueryKey } from '@tanstack/react-query'
import { CampaignFlow } from '../../../types/campaignFlow'
import CampaignFlowService from 'services/campaignFlowService'

const getCampaignFlowId = async (
  { queryKey }: { queryKey: QueryKey },
  getAuthToken: () => Promise<string>
): Promise<CampaignFlow | undefined> => {
  const token = await getAuthToken()
  const agencyId = queryKey[1] as string
  const service = new CampaignFlowService(token)

  const result = await service.campaignFlowService.get('GetAgencyCode', {
    agencyId,
  })

  return result.data
}

export default getCampaignFlowId
